export const environmentData = {
  run: "production",
  development: {
    clientId: "d6cea7c3-4ba0-40f2-9c48-4f77119c2c64",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid d6cea7c3-4ba0-40f2-9c48-4f77119c2c64/User.Impersonation",
    apiBaseURL: "https://dev-api-globalstoredashboard.azurewebsites.net/api",
  },
  production: {
    clientId: "a4284cb7-030a-4ab4-8742-98501daefc12",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid a4284cb7-030a-4ab4-8742-98501daefc12/user_impersonation",
    apiBaseURL: "https://prod-api-gloabalstoredashboard.azurewebsites.net/api",
  },
};
